import { render, staticRenderFns } from "./CreateTopic.vue?vue&type=template&id=1ee16f52"
import script from "./CreateTopic.vue?vue&type=script&lang=js"
export * from "./CreateTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports